export default str => `${str.charAt(0).toUpperCase()}${str.slice(1)}`;



// WEBPACK FOOTER //
// ./scripts/util/ucFirst.js